<template>
    <f7-page name="sucho-v-povrchovych-vodach-chart" @page:init="onPageInit">
        <f7-navbar>
            <f7-nav-left>
                <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
            </f7-nav-left>
            <f7-nav-title sliding>{{ pageTitle }}</f7-nav-title>
            <f7-nav-right>
                <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
                <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
            </f7-nav-right>
        </f7-navbar>

        <template v-if="notEmptyObject(stationDataForChart)">

            <div class="mt-1">
                <highcharts ref="svtHighcharts" :updateArgs="[true, true, true]" :options="chartOptions"></highcharts>
            </div>

            <div class="mt-1">
                <div style="float:left; width:20px; height: 3px; margin:9px 5px 0px 5px; background: #05FA67;"></div>
                <small><strong>Qd</strong> - priemerné denné prietoky v roku {{ selectedYear }}</small><br>
                <div style="float:left; width:20px; height: 3px; margin:9px 5px 0px 5px; background: #6F1106;"></div>
                <small><strong>Qa</strong> - dlhodobý priemerný prietok za obdobie 1961-2000</small>
            </div>
        </template>

    </f7-page>
</template>
<script>
    import Axios from "axios";
    import SHMUconf from "../js/SHMUconf";
    import {Chart} from 'highcharts-vue'
    import Highcharts from 'highcharts';

    import svtChart from './situacia-na-vodnych-tokoch-chart-options'

    Highcharts.setOptions({
        lang: {
            weekdays: ['Nedeľa','Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
            shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
            months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December']
        },
        global: {
            useUTC: true
        }
    });


    export default {
        components: {
            highcharts: Chart
        },
        data: function () {
            return {
                pageTitle: 'Sucho v povrchových vodách',
                stationIdForChart: null,
                stationDataForChart: {},
                selectedYear: null,
                chartOptions: svtChart,
            };
        },
        watch: {
            stationDataForChart() {
                this.generateChart()
            }
        },
        mounted() {
            const self = this;
            // otvorime hlavne menu
            this.$f7.accordion.close('.shmu-i-vodne-zdroje');
            this.$f7.accordion.open('.shmu-i-vodne-zdroje');
        },
        destroy() {
            clearInterval(this.tCheckInterval);
            this.stationIdForChart = null;
            this.stationDataForChart = {};
        },
        methods: {
            onPageInit() {
                this.stationIdForChart = this.$f7route.params.station_id;
                if (this.$f7route.params.selected_year) {
                  this.selectedYear = this.$f7route.params.selected_year;
                }
                this.pageReload(null, true);
            },
            pageReload(event, isInit) {
                const self = this;

                if (this.stationIdForChart && (isInit || (this.$moment().unix() - this.lastUpdated) > 60)) {
                    this.loadHistoryData(this.stationIdForChart);
                } else {
                    if (!this.stationIdForChart) {
                        self.$f7.dialog.alert('Identifikátor stanice nebol správne určený!', 'Nastala chyba');
                    }
                }
            },
            loadHistoryData(station_id) {
                const self = this;

                self.$f7.dialog.preloader('Načítavam...');
                let addon = '';
                if (self.selectedYear) {
                  addon = '&year=' + self.selectedYear
                }

                Axios.get(SHMUconf.API_BASE_URL + 'hydrodrought/gethistorydata?station=' + station_id + addon, {
                    crossDomain: true,
                    cache: false,
                })
                    .then((response) => {
                        if (!response.data.error) {
                            self.stationDataForChart = response.data;
                            self.pageTitle = self.stationDataForChart.station.station_name + ' - ' + self.stationDataForChart.station.river_name + ' - Sucho v povrchových vodách';
                            self.lastUpdated = self.$moment().unix();
                            // clearInterval(this.tCheckInterval);
                            // this.tCheckInterval = setInterval(this.checkLastUpdated, 60 * 60 * 1000); // overujem kazdych 5 min
                        } else {
                            self.$f7.dialog.alert('Nepodarilo sa načítať údaje pre vykreslenie grafu', 'Nastala chyba');
                        }
                        self.$f7.dialog.close();
                    }).catch((error) => {
                    self.$f7.dialog.close();
                    self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
                });

            },
            checkLastUpdated() {
                if ((this.$moment().unix() - this.lastUpdated) >= 30*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
                    this.pageReload(null, false);
                }
            },
            generateChart() {
                // priprav data pre chart
                let vals = [];

                this.chartOptions.subtitle.text = this.stationDataForChart.station.station_name +
                    ' - ' + this.stationDataForChart.station.river_name;


                this.chartOptions.yAxis.min = this.stationDataForChart.chart.min;
                this.chartOptions.yAxis.max = this.stationDataForChart.chart.max;

                this.chartOptions.yAxis.plotBands = this.stationDataForChart.chart.yplotbands;
                this.chartOptions.yAxis.plotLines = this.stationDataForChart.chart.yplotline;

                let z = this.chartOptions.series.find(item => (item.id) === 'dpr');
                z.data = this.stationDataForChart.chart.chartdata[0].data;
                z.md_data = this.stationDataForChart.chart.md_data;


            },


        }

    };
</script>

